module.exports = __webpack_public_path__ + "img/youqinglianjie.61e30a71.jpg";